import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import moment from "moment";
import useWillConstrain from "../hooks/use-will-constrain";

function CurrentDatetimeFilter(props) {

    const [value] = React.useState(moment().format(props.format));

    useWillConstrain(props.name, value)

    return null;
}

CurrentDatetimeFilter.defaultProps = {
    name: 'current_datetime',
    format: 'YYYY-MM-DD hh:mm:ssZ',
};

CurrentDatetimeFilter.propTypes = {
    name: PropTypes.string,
    format: PropTypes.string,
};

export default observer(CurrentDatetimeFilter);
